// @ts-check

/** Opens the canvas panel on a document. detail: { documentId, sessionId? } */
const OPEN_CANVAS_PANEL_EVENT = "open-canvas-panel"

/** Below this width the panel would cover the chat (same breakpoint as useIsMobile). */
const PHONE_MAX_WIDTH = 767

/**
 * The id of the document a finished create_canvas call made, or null.
 * The tool result is the document API body, usually as a JSON string.
 * @param {{ tool_name?: string, tool_result?: unknown } | null | undefined} event
 * @returns {string | null}
 */
function createdDocumentId(event) {
  if (event?.tool_name !== "create_canvas") return null
  let result = event.tool_result
  if (typeof result === "string") {
    try {
      result = JSON.parse(result)
    } catch {
      return null
    }
  }
  const id = /** @type {any} */ (result)?.document?._id
  return typeof id === "string" && id !== "" ? id : null
}

/**
 * Opens the document beside the chat as soon as the agent has created it.
 * A phone does not get it: the panel would cover the chat while the reply
 * streams, and the "Open the document" button opens it after the reply.
 * @param {string} sessionId
 * @param {{ tool_name?: string, tool_result?: unknown }} event a ToolCallCompleted event
 * @param {{ isPhone?: boolean }} [options]
 * @returns {boolean} true when the panel was asked to open
 */
function openCreatedDocument(sessionId, event, { isPhone = window.matchMedia(`(max-width: ${PHONE_MAX_WIDTH}px)`).matches } = {}) {
  const documentId = createdDocumentId(event)
  if (documentId == null || isPhone) return false
  document.dispatchEvent(new CustomEvent(OPEN_CANVAS_PANEL_EVENT, { detail: { documentId, sessionId } }))
  return true
}

export { OPEN_CANVAS_PANEL_EVENT, createdDocumentId, openCreatedDocument }
